__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "fc_auth_borrower_portal_auth_mfe";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("classnames", "2.5.1", () => (__webpack_require__.e(77).then(() => (() => (__webpack_require__(7077))))));
			register("operation-diameter", "4.7.10", () => (Promise.all([__webpack_require__.e(755), __webpack_require__.e(318), __webpack_require__.e(173)]).then(() => (() => (__webpack_require__(9755))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(108), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(8108))))));
			register("react", "18.3.1", () => (__webpack_require__.e(685).then(() => (() => (__webpack_require__(6685))))));
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(815).then(() => (() => (__webpack_require__(3815))))));
			initExternal(9801);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};